export const getCronLogId = function(state) {
    return state.cron_log_id
}

export const getPage = function(state) {
    return state.page
}

export const getPerPage = function(state) {
    return state.perpage
}

export const getLastPage = function(state) {
    return state.last_page
}

export const getLogCounts = function(state) {
    return state.tot_logs
}

export const getResponsePayload = function(state) {
    return state.responsePayload
}